<script>
  import {
    getLoggedIn,
    getCartCount,
    subcategoryHeight,
    getNavState,
    getAccessibilityRedesignRenderState,
  } from '../../../../../../../js/stores';
  import { filterNavItems } from '../../../../../../../js/navItemFilters';

  import ButtonLink from '../../../../../ButtonLink/ButtonLink.svelte';
  import CategoryLink from './CategoryLink/CategoryLink.svelte';
  import Subcategory from './Subcategory/Subcategory.svelte';

  const loggedInStore = getLoggedIn();
  const cartCountStore = getCartCount();
  const navStateStore = getNavState();
  const accessibilityRedesignRenderStore = getAccessibilityRedesignRenderState();

  export let navItems = [];
  export let cartPrimary = false;
  export let cartSecondary = false;
  export let isOpen = false;

  const initialheight = 0;

  $: padTop = !cartPrimary;
  $: borderTop = cartSecondary && !$accessibilityRedesignRenderStore;

  $: filteredItems = filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
  });

  $: categoryListStyle = `min-height: ${
    $subcategoryHeight > 0 && $navStateStore.subcategory ? $subcategoryHeight : initialheight
  }px;`;
</script>

<ul
  class="CategoryList"
  class:padTop
  class:borderTop
  class:isOpen={isOpen && $accessibilityRedesignRenderStore}
  class:category-list-accessibility-redesign={$accessibilityRedesignRenderStore && !cartPrimary && !cartSecondary}
  style={categoryListStyle}
>
  {#each filteredItems as item (item)}
    {#if item.type === 'category'}
      <li class="category-item" class:hidden={item.hidden}>
        <Subcategory id={item.id} title={item.title} navItems={item.navItems} description={item.description} />
      </li>
    {:else if item.type === 'link'}
      {#if item.linkStyle === 'primary' || item.linkStyle === 'secondary'}
        <li class="button-item" class:hidden={item.hidden}>
          <ButtonLink id={item.id} title={item.title} url={item.url} linkStyle={item.linkStyle} width="100%" />
        </li>
      {:else}
        <li class="link-item" class:hidden={item.hidden}>
          <CategoryLink id={item.id} title={item.title} url={item.url} description={item.description} />
        </li>
      {/if}
    {/if}
  {/each}
</ul>

<style>.CategoryList {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  transition: min-height 250ms cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  display: block;
  padding: 0 0 15px 0;
}
.CategoryList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.CategoryList > li::before {
  display: none;
}
.CategoryList .button-item {
  padding-left: 20px;
  padding-right: 20px;
}
.CategoryList .button-item:last-child {
  padding-bottom: 5px;
}
.CategoryList .button-item:not(:first-child) {
  padding-top: 10px;
}
.CategoryList .button-item + .link-item {
  padding-top: 10px;
}

.category-list-accessibility-redesign {
  opacity: 0;
  transition: transform 150ms, opacity 150ms;
  transform-origin: top center;
  transform: translateY(-10px);
}
.category-list-accessibility-redesign.isOpen {
  opacity: 1;
  transform: translateY(0);
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 150ms linear;
  transition-delay: 150ms;
}

.padTop {
  padding-top: 15px;
}
.padTop .button-item:first-child {
  padding-top: 5px;
}

.borderTop {
  border-top: 1px solid var(--color-border, #d9d9d9);
}</style>
